import React from 'react';

// Read-only renderer for the TipTap JSON the backend produces
// (paragraph / heading / bold / table / bulletList / orderedList).

const renderInline = (content) =>
  (content || []).map((n, i) => {
    if (n.type === 'hardBreak') return <br key={i} />;
    if (n.type !== 'text') return null;
    const bold = (n.marks || []).some((m) => m.type === 'bold');
    return bold ? <strong key={i}>{n.text}</strong> : <React.Fragment key={i}>{n.text}</React.Fragment>;
  });

const cellText = (cell) =>
  (cell.content || []).map((p) => (p.content || []).map((t) => t.text || '').join('')).join('\n');

export const nodeText = (node) =>
  node?.type === 'text' ? node.text || '' : (node?.content || []).map(nodeText).join('');

function Table({ node }) {
  return (
    <div className="my-3 overflow-x-auto rounded-md border border-borderGrey">
      <table className="w-full text-[11px]">
        <tbody>
          {(node.content || []).map((row, ri) => {
            const isHeader = row.content?.[0]?.type === 'tableHeader';
            return (
              <tr key={ri} className={isHeader ? 'bg-primary text-white' : ri % 2 ? 'bg-white' : 'bg-muted/40'}>
                {(row.content || []).map((cell, ci) =>
                  isHeader ? (
                    <th key={ci} className="whitespace-nowrap px-2 py-1 text-left font-semibold">
                      {cellText(cell)}
                    </th>
                  ) : (
                    <td key={ci} className="whitespace-pre px-2 py-1 align-top">
                      {cellText(cell)}
                    </td>
                  )
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default function DocPreview({ doc, renderHeading }) {
  if (!doc?.content?.length) return null;
  return (
    <div className="prose prose-sm max-w-none text-token-md leading-relaxed">
      {doc.content.map((n, i) => {
        switch (n.type) {
          case 'paragraph':
            return (
              <p key={i} className="mb-3">
                {renderInline(n.content)}
              </p>
            );
          case 'heading': {
            const text = nodeText(n);
            const Tag = n.attrs?.level === 3 ? 'h3' : 'h2';
            return (
              <Tag key={i} className="mb-2 mt-5 flex items-center justify-between gap-2 text-token-lg font-semibold">
                <span>{text}</span>
                {renderHeading ? renderHeading(text) : null}
              </Tag>
            );
          }
          case 'bulletList':
          case 'orderedList': {
            const L = n.type === 'bulletList' ? 'ul' : 'ol';
            return (
              <L key={i} className="mb-3 list-inside list-disc">
                {(n.content || []).map((li, j) => (
                  <li key={j}>{nodeText(li)}</li>
                ))}
              </L>
            );
          }
          case 'table':
            return <Table key={i} node={n} />;
          default:
            return null;
        }
      })}
    </div>
  );
}
